import { Button, Inline, Stack, Text } from '@front10/base-elements';
import { Icon } from '../../../packages/base-elements/Icon/Icon';
import { useTranslation } from '@front10/utils';
import * as React from 'react';
import { PassengerProps } from './PeopleCounter';

export type Layout = 'inline' | 'block';

const styles = {
  grow: {
    flex: 1
  },
  controls: {
    container: {
      borderStyle: 'solid',
      borderWidth: 'default',
      borderRadius: 'default',
      borderColor: 'borders',
      height: '48px'
    },
    button: { display: 'inline-flex', alignItems: 'center', px: '8px' },
    counter: {
      variant: 'text.fontSize5',
      color: 'text',
      alignSelf: 'center',
      width: '30px',
      textAlign: 'center'
    }
  }
} as const;

interface PeopleSelectorItemProps {
  config: PassengerProps;
  count?: number;
  onAdd?: () => void;
  onRemove?: () => void;
  addButtonDisabled?: boolean;
  removeButtonDisabled?: boolean;
  layout?: Layout;
}

export function PeopleCounterItem(props: PeopleSelectorItemProps) {
  const count = props.count ?? 0;
  const Container = props.layout === 'inline' ? Stack : Inline;
  const translate = useTranslation();
  const label = translate(props.config.label);

  return (
    <Container alignY="center" align="start" gap={2} sx={styles.grow} childrenBottomMargin>
      <Stack gap={1} sx={styles.grow}>
        <Text variant="fontSize5" color="text">
          {label}
        </Text>
        {props.config.description && (
          <Text variant="fontSize7" color="text">
            {translate(props.config.description)}
          </Text>
        )}
      </Stack>
      <Inline
        sx={styles.controls.container}
        variant="forms.spinButton"
        data-disabled={props.addButtonDisabled && props.removeButtonDisabled}
      >
        <Button
          variant="text"
          aria-label={translate('cmp-people-counter-remove-btn-label', 'Decrease {label}', {
            label
          })}
          onClick={props.onRemove}
          sx={styles.controls.button}
          disabled={props.removeButtonDisabled}
        >
          <Icon aria-hidden={true} size={20} icon="remove" />
        </Button>
        <Text aria-live="polite" as="span" sx={styles.controls.counter}>
          {count}
        </Text>
        <Button
          variant="text"
          aria-label={translate('cmp-people-counter-add-btn-label', 'Increase {label}', { label })}
          onClick={props.onAdd}
          sx={styles.controls.button}
          disabled={props.addButtonDisabled}
        >
          <Icon aria-hidden={true} size={20} icon="add" />
        </Button>
      </Inline>
    </Container>
  );
}
